<div class="flex flex-column gap-2 border-1 border-round-lg border-purple-100 p-3 w-full">
    <!-- Récapitulatif, toujours affiché : l'action reste lisible une fois l'objet revu ou supprimé -->
    <div class="flex align-items-center gap-2">
        <i class="bi bi-ai-sparkles-solo text-purple-500"></i>
        <span class="flex-1 text-sm text-color">{{ action.summary }}</span>
        <!-- État servi par le serveur : violet à revoir, orange à décider, vert gardé, gris défait ou écarté -->
        @if (tagSeverity) {
        <p-tag [value]="action.processingStatusLabel" [severity]="tagSeverity" [rounded]="true"></p-tag>
        } @else {
        <p-tag [value]="action.processingStatusLabel" [rounded]="true" [dt]="aiTag"></p-tag>
        }
    </div>

    <!-- Proposition : ce que signe celui qui l'applique, champ par champ (rien pour une suppression) -->
    @if (action.proposed && action.details.length) {
    <div class="flex flex-column gap-1 text-sm pl-4">
        @for (detail of action.details; track $index) {
        <span><span class="text-color-secondary">{{ detail.label }} :</span> {{ detail.value }}</span>
        }
    </div>
    }

    <!-- À gauche, qui a tranché l'action et quand, ou jusqu'à quand la proposition attend ;
         à droite, le lien et les boutons, chaque bouton seulement si le serveur l'accepterait -->
    @if (statusLine || canOpenTarget || canKeep || canUndo || canApply || canReject) {
    <div class="flex align-items-center gap-2">
        <span class="flex-1 text-xs text-color-secondary">{{ statusLine }}</span>
        @if (canOpenTarget) {
        <p-button label="Consulter" icon="pi pi-external-link" size="small" severity="secondary" [text]="true"
            [rounded]="true" (onClick)="onClickOpenTarget()"></p-button>
        }
        @if (canUndo) {
        <p-button label="Annuler" icon="fa-solid fa-rotate-left" size="small" severity="help" [outlined]="true"
            [rounded]="true" [disabled]="pending" (onClick)="onClickUndo()"></p-button>
        }
        @if (canKeep) {
        <p-button label="Conserver" icon="pi pi-check" size="small" severity="help" [rounded]="true"
            [loading]="pending" (onClick)="onClickKeep()"></p-button>
        }
        @if (canReject) {
        <p-button label="Refuser" icon="pi pi-times" size="small" severity="help" [outlined]="true"
            [rounded]="true" [disabled]="pending" (onClick)="onClickReject()"></p-button>
        }
        @if (canApply) {
        <p-button label="Appliquer" icon="pi pi-check" size="small" severity="help" [rounded]="true"
            [loading]="pending" (onClick)="onClickApply()"></p-button>
        }
    </div>
    }
</div>
